import { render, staticRenderFns } from "./maintain.vue?vue&type=template&id=12b59d46&"
import script from "./maintain.vue?vue&type=script&lang=js&"
export * from "./maintain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports